import React, { Component } from 'react';
import { CheckList } from 'components/forms/ChkboxList.style.js';

class ChkboxList extends Component {
  constructor(props) {
    super(props);
    var values = {};
    props.values.forEach(function(e) {
      var safeName = e.replace(/\s/g, '').toLowerCase();
      values[safeName] = false;
    }, this);
    this.state = values;
  }

  onChange(key, value) {
      this.setState({ [key]: value }, (state) => {
          this.props.onChange(this.state);
      })
  }

  render() {
    return (
      <CheckList>
        <ul>
          { this.props.values.map((value, i) => (
            <li key={i}>
                <input
                    onChange={(e) => this.onChange(value.replace(/\s/g, '').toLowerCase(), e.target.checked)}
                    id={value.replace(/\s/g, '').toLowerCase()}
                    name={value.replace(/\s/g, '').toLowerCase()}
                    type='checkbox'
                    value={this.state[value]}
                />
                <label htmlFor={value.replace(/\s/g, '').toLowerCase()}>
                  {value}
                </label>
            </li>
          ))}
        </ul>
      </CheckList>
    );
  }
}

export default ChkboxList;



// WEBPACK FOOTER //
// ./src/components/forms/ChkboxList.js